export class Address {
  private _city: string;
  private _postalCode: string;
  private _road: string;
  private _number: number;
  private _letter?: string;
  private _floor?: string;
  private _door?: string;
  private _darId?: string;

  constructor(
    city: string,
    postalCode: string,
    road: string,
    number: number,
    letter?: string,
    floor?: string,
    door?: string,
    darId?: string
  ) {
    this._city = city;
    this._postalCode = postalCode;
    this._road = road;
    this._number = number;
    this._letter = letter;
    this._floor = floor;
    this._door = door;
    this._darId = darId;
  }

  public get city(): string {
    return this._city;
  }

  public get postalCode(): string {
    return this._postalCode;
  }

  public get road(): string {
    return this._road;
  }

  public get number(): number {
    return this._number;
  }

  public get letter(): string {
    return this._letter ?? '';
  }

  public get floor(): string {
    return this._floor ?? '';
  }

  public get door(): string {
    return this._door ?? '';
  }

  public get darId(): string {
    return this._darId ?? '';
  }

  public get fullAddress(): string {
    let address = `${this.road} ${this.number}`;

    if (this.letter) {
      address += this.letter;
    }

    if (this.floor) {
      address += ` ${this.floor}.`;
    }
    if (this.door) {
      address += ` ${this.door}.`;
    }

    address += `, ${this.postalCode} ${this.city}`;

    return address;
  }
}
